<!--
  ~ Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
  ~ Venelin Iliev <http://veneliniliev.com>
  -->

<div class="form-group" [formGroup]="form">
  <label>{{ 'EVENTS_SELECT.EVENTS' | translate }}</label>
  <ng-container *ngIf="isInModal; else outsideModal">
  <ng-select
    [multiple]="true"
    [items]="data | async"
    bindLabel="formattedName"
    bindValue="id"
    [loading]="loader"
    [formControlName]="'events_fake'"
    (add)="add($event)"
    (remove)="remove($event.value.id)"
    (clear)="clear()"
    [typeahead]="input$"
  >
    <ng-template ng-typetosearch-tmp>
      <div class="ng-option disabled">
        {{ 'START_TYPING' | translate }}
      </div>
    </ng-template>

    <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
      <div class="event-select-option-wrapper">
        <div class="event-name">{{ item.name }}</div>
        <div class="event-dates">
          {{ item.date_from | amDateFormat : env.momentDateFormat }} -
          {{ item.date_to | amDateFormat : env.momentDateFormat }}
        </div>
        <div class="event-venue-wrapper">
          <div class="event-venue-name" *ngIf="item.venue">{{ item.venue.name }} &#64;</div>
          <div class="event-venue-city" *ngIf="item.venue?.city">{{ item.venue.city.name }},</div>
          <div class="event-venue-country" *ngIf="item.venue?.city?.country">{{ item.venue.city.country.name }}</div>
        </div>
      </div>
    </ng-template>

    <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
      <div class="ng-option disabled">
        <div>{{ 'NO_DATA_FOUND' | translate }} "{{ searchTerm }}"</div>
        <button type="button" class="btn btn-primary btn-xs w-100" (click)="addNew(searchTerm)">
          <i class="fal fa-plus"></i> {{ 'EVENTS_SELECT.ADD_NEW' | translate }}
        </button>
      </div>
    </ng-template>
  </ng-select>
  </ng-container>

  <ng-template #outsideModal>
    <ng-select
      [multiple]="true"
      [items]="data | async"
      bindLabel="formattedName"
      bindValue="id"
      [loading]="loader"
      [formControlName]="'events_fake'"
      (add)="add($event)"
      (remove)="remove($event.value.id)"
      (clear)="clear()"
      appendTo="body"
      [typeahead]="input$"
    >
      <ng-template ng-typetosearch-tmp>
        <div class="ng-option disabled">
          {{ 'START_TYPING' | translate }}
        </div>
      </ng-template>

      <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
        <div class="event-select-option-wrapper">
          <div class="event-name">{{ item.name }}</div>
          <div class="event-dates">
            {{ item.date_from | amDateFormat : env.momentDateFormat }} -
            {{ item.date_to | amDateFormat : env.momentDateFormat }}
          </div>
          <div class="event-venue-wrapper">
            <div class="event-venue-name" *ngIf="item.venue">{{ item.venue.name }} &#64;</div>
            <div class="event-venue-city" *ngIf="item.venue?.city">{{ item.venue.city.name }},</div>
            <div class="event-venue-country" *ngIf="item.venue?.city?.country">{{ item.venue.city.country.name }}</div>
          </div>
        </div>
      </ng-template>

      <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
        <div class="ng-option disabled">
          <div>{{ 'NO_DATA_FOUND' | translate }} "{{ searchTerm }}"</div>
          <button type="button" class="btn btn-primary btn-xs w-100" (click)="addNew(searchTerm)">
            <i class="fal fa-plus"></i> {{ 'EVENTS_SELECT.ADD_NEW' | translate }}
          </button>
        </div>
      </ng-template>
    </ng-select>
  </ng-template>
</div>
